import type { GTM } from "../GTMInterfaces";
import { ServiceWithCashbackAdapter } from "./ServiceWithCashbackAdapter";
import { getServicesCashbackPartnerCollection } from "./servicesWithCashbackFromPartners";

export function enrichServiceWithCashbackFromPartnerData(service: GTM.ServiceExtended) {
  const servicesWithCashbackFromPartner = getServicesCashbackPartnerCollection();
  const adapter = new ServiceWithCashbackAdapter(servicesWithCashbackFromPartner);
  return adapter.fromGTMExtendedService(service);
}
